/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-with-filled-button[_ngcontent-%COMP%]{min-height:calc(100vh - 340px);margin-top:32px}.nuestros-productos-d[_ngcontent-%COMP%]{height:32px;width:100%;color:#231d19;font-family:\"Itau Display\";font-size:24px;font-weight:300;letter-spacing:0;line-height:32px;margin-bottom:20px}.tasa-interes[_ngcontent-%COMP%]{color:#605751;font-size:14px;letter-spacing:0;line-height:20px}"];
export { styles as styles };
